import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { englishIqItemSchema, englishIqMilestoneSchema } from '../schemas';

const answerEnglishIqV1DataSchema = z.object({
  exhausted: z.boolean(),
  item: englishIqItemSchema.nullable(),
  milestone: englishIqMilestoneSchema.nullable(),
  token: z.string(),
});

export type IAnswerEnglishIqV1Data = z.infer<typeof answerEnglishIqV1DataSchema>;

export const answerEnglishIqV1ResponseSchema: z.ZodSchema<IAPI<IAnswerEnglishIqV1Data>> =
  createApiResponseSchema(answerEnglishIqV1DataSchema) as z.ZodSchema<IAPI<IAnswerEnglishIqV1Data>>;

export type IAnswerEnglishIqV1Response = IAPI<IAnswerEnglishIqV1Data>;
